// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DonutChart_chart__VmoLQ {
  margin: 0 auto;
  padding: 0;
  list-style-type: none;
  position: relative;
  overflow: hidden;
}
.DonutChart_chart__VmoLQ li {
  position: absolute;
  top: 100%;
  left: 0;
  width: inherit;
  height: inherit;
  transform-origin: 50% 0;
}
.DonutChart_chart__VmoLQ li::before {
  content: "";
  position: absolute;
  top: 0;
  width: 100%;
  height: 1px;
  left: -100%;
  background: white;
}`, "",{"version":3,"sources":["webpack://./src/pages/reporting/%5Bid%5D/DonutChart/index.module.scss","webpack://./src/pages/reporting/[id]/DonutChart/index.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;ACCF;ADCE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;ACCJ;ADCI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;ACCN","sourcesContent":[".chart {\n  margin: 0 auto;\n  padding: 0;\n  list-style-type: none;\n  position: relative;\n  overflow: hidden;\n\n  li {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: inherit;\n    height: inherit;\n    transform-origin: 50% 0;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      width: 100%;\n      height: 1px;\n      left: -100%;\n      background: white;\n    }\n  }\n}\n",".chart {\n  margin: 0 auto;\n  padding: 0;\n  list-style-type: none;\n  position: relative;\n  overflow: hidden;\n}\n.chart li {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: inherit;\n  height: inherit;\n  transform-origin: 50% 0;\n}\n.chart li::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 1px;\n  left: -100%;\n  background: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chart": `DonutChart_chart__VmoLQ`
};
export default ___CSS_LOADER_EXPORT___;
